import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {BorderModel} from '../../shared/dto/border.model';
import {BorderService} from '../../shared/service/border.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {Router} from '@angular/router';
import {EmployeeDTO} from '../../shared/dto/employee.model';
import swal from 'sweetalert2';
import {MatPaginator, MatTableDataSource} from '@angular/material';
import {MatSort} from '@angular/material/sort';
import {WorkFlowStageModel} from '../../shared/dto/work-flow-stage-model';
import {CountryModel} from '../../model/country.model';
import {SearchRequestDetailModel} from '../../shared/dto/search-request-detail.model';
import {Border} from '../../model/border.model';
import {SearchBoderRequestDetailModel} from '../../model/search.border.request.details.model';
import {EmployeeDesignationPopupComponent} from '../employee-mgt/employee-designation/employee-designation-popup/employee-designation-popup.component';
import {ActionMode} from '../../shared/enums/action-mode.enum';
import {BoarderPopupComponent} from './boarder-popup/boarder-popup.component';
import {EmployeePopupComponent} from '../employee-mgt/employee/employee-popup/employee-popup.component';

@Component({
  selector: 'app-boarder-mgt',
  templateUrl: './boarder-mgt.component.html',
  styleUrls: ['./boarder-mgt.component.scss']
})
export class BoarderMgtComponent implements OnInit {
  public borderForm: FormGroup;
  public borderConfigItems: BorderModel [] = [];
  public dto: BorderModel[] = [];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  displayedColumns: string[] = ['name', 'country', 'address', 'contactNo', 'email', 'fax', 'status', 'action'];
  dataSource: MatTableDataSource<any>;
  public href: string = '';
  public countryList: CountryModel[] = [];
  @Input() items: BorderModel[];

  constructor(private borderService: BorderService,
              public modalService: NgbModal,
              private spinnerService: NgxUiLoaderService,
              private tokenStorageService: TokenStorageService,
              private router: Router) {
  }

  ngOnInit() {
    this.borderForm = new FormGroup({
      name: new FormControl(null),
      country: new FormControl(null),
      status: new FormControl(null),
    });
    this.href = this.router.url;
    this.onLoadGetData();
    // this.loadBorderDetails();
    this.getAllData();
    this.loadAllCountries();
  }


  getAllData() {
    this.borderService.getAllBoderDetails().subscribe(
      (data: BorderModel[]) => {
        this.dto = data;
        this.dataSource = new MatTableDataSource(this.dto);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    )
  }

  onLoadGetData(): void {
    const borderDTO = new SearchBoderRequestDetailModel(
      null,
      null,
      null
    );

    // this.loadSearchResultList(borderDTO);
  }

  onSubmitSearch(form: FormGroup) {
    const searchRequestDTOS = new SearchBoderRequestDetailModel(form.value.name, form.value.country, form.value.status);
    this.loadSearchResultList(searchRequestDTOS);
  }

  loadSearchResultList(borderDTO: SearchBoderRequestDetailModel): void {
    this.spinnerService.start();
    this.borderService.getBorderDetails(borderDTO).subscribe(
      (data: BorderModel[]) => {
        this.dto = data;
        this.dataSource = new MatTableDataSource(this.dto);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (error) => {
        this.spinnerService.stop();
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        this.spinnerService.stop();
        if (this.dto == null || this.dto.length === 0) {
          swal.fire('Sorry', 'No result found.', 'error');
          this.getAllData();
        } else {
          this.borderService.clearBorderSearchDetails();
          this.borderService.setBorderSearchDetails(
            this.borderConfigItems
          );
        }
      }
    );
  }

  loadBorderDetails() {
    this.borderService.getAllBorderDetails().subscribe(
      (data: BorderModel[]) => {
        this.borderConfigItems = data;
      }
    )
  }

  loadAllCountries() {

    this.borderService.getAllCountries().subscribe(
      (data: CountryModel[]) => {
        this.countryList = data;
      }
    );
  }

  onClickReset() {
    this.borderForm.reset({
      name: null,
      country: null,
      status: null,
    });
    this.onLoadGetData();
  }

  onClickNew() {
    const modalRef = this.modalService.open(BoarderPopupComponent, {
      windowClass: 'xlModal'
    });
    // modalRef.componentInstance.name = 'Add New Employee';
    modalRef.componentInstance.selectedMode = ActionMode.ADD;
    modalRef.componentInstance.designationMgtCopy_ = this.borderConfigItems;
    modalRef.result.then((data: string) => {
      if (data == 'Saved') {
        this.getAllData();
        this.loadBorderDetails();
      }
    }, () => {

    });
  }

  onClickUpdate(Item) {
    const modalRef = this.modalService.open(BoarderPopupComponent, {
      windowClass: 'xlModal'
    });
    modalRef.componentInstance.name = 'Update Employee Details';
    modalRef.componentInstance.id = Item.id;
    modalRef.componentInstance.name = Item.name;
    modalRef.componentInstance.country = Item.country.code;
    modalRef.componentInstance.addressLine1 = Item.addressLine1;
    modalRef.componentInstance.addressLine2 = Item.addressLine2;
    modalRef.componentInstance.addressLine3 = Item.addressLine3;
    modalRef.componentInstance.contactNo = Item.contactNo;
    modalRef.componentInstance.email = Item.email;
    modalRef.componentInstance.fax = Item.fax;
    modalRef.componentInstance.status = Item.status.code;
    modalRef.componentInstance.employeeMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.UPDATE;
    modalRef.result.then(
      (data: string) => {
        if (data == 'Saved') {
          this.getAllData();
          this.loadBorderDetails();
        }
      },
      () => {
      }
    );
  }

  onClickView(Item) {
    const modalRef = this.modalService.open(BoarderPopupComponent, {
      windowClass: 'xlModal'
    });
    modalRef.componentInstance.name = 'View Employee Details';
    modalRef.componentInstance.id = Item.id;
    modalRef.componentInstance.name = Item.name;
    modalRef.componentInstance.country = Item.country.code;
    modalRef.componentInstance.addressLine1 = Item.addressLine1;
    modalRef.componentInstance.addressLine2 = Item.addressLine2;
    modalRef.componentInstance.addressLine3 = Item.addressLine3;
    modalRef.componentInstance.contactNo = Item.contactNo;
    modalRef.componentInstance.email = Item.email;
    modalRef.componentInstance.fax = Item.fax;
    modalRef.componentInstance.status = Item.status.code;
    modalRef.componentInstance.employeeMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.VIEW;
  }

  onDelete(Item) {
    swal.fire({
      title: 'Are you sure, you want to delete?',
      text: '',
      showCancelButton: true,

      confirmButtonText: 'Yes'
    }).then((result) => {
        if (result.value) {
          const id = Item.id;
          this.borderService.deleteEmployee(id).subscribe(
            (res: boolean) => {
              if (res === true) {
                swal.fire('Success', 'Details Deleted successfully', 'success');
                // this.items.splice(Item.id, 1);
                this.getAllData();
              } else if (res === false) {
                swal.fire('Sorry!', 'Details can\'t be deleted.Ongoing records available for the selected user..!', 'error');
              }
            },
            (error) => {
              console.log(error);
              swal.fire('Sorry!', 'Something went wrong...!', 'error');
            },
            () => {
            }
          );
        }
      }, reason => {
      }
    );
  }
}
